import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles/variables';
const PopularKeyword = ({ keyword, onClick, className }) => {
    const wrapperClass = [className || '', css(styles.keyword)].join(' ');
    const handleOnClick = () => onClick(keyword);
    return (React.createElement("span", { onClick: handleOnClick, className: wrapperClass, "data-test": "searchKeyword" }, keyword));
};
const styles = StyleSheet.create({
    keyword: {
        height: 27,
        lineHeight: '27px',
        padding: '0 14px',
        fontSize: 12,
        color: Colors.GrayDarkest,
        backgroundColor: Colors.BackgroundLightGray,
        borderRadius: 4,
        cursor: 'pointer',
        transition: 'all 0.3s',
        ':hover': {
            color: Colors.Primary,
            borderColor: Colors.Primary,
        },
        ':focus': {
            outline: 'none',
        },
    },
});
export default PopularKeyword;
